<template>
    <div
        class="cinemaListWrap"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="0"
    >
        <!-- <nav-bar></nav-bar> -->
        <div class="filterBar fr ac jsb">
            <div class="addressFilter fr ac">
                <div @click="switchCity" class="fr ac">
                    <img class="downIco" src="../../../static/imgs/movie/down.png" alt="">
                    <span>{{selectedCity}}</span>
                </div>
                <div @click="districtFilter" class="fr ac">
                    <img class="downIco" src="../../../static/imgs/movie/down.png" alt="">
                    <span>{{selectedCounty}}</span>
                </div>
            </div>
            <img @click="searchCinema" class="searchIco" src="../../../static/imgs/movie/search.png" alt="">
        </div>
        <div class="listWrap">
            <div
                @click="goCinemaMovie(item.id)"
                v-for="(item, index) in cinemaList"
                :key="index"
                class="listItem fr ac jsb"
            >
                <div class="infoBox fc jsb">
                    <h3>{{item.name}}</h3>
                    <span class="addr ellipsis">{{item.address}}</span>
                    <div class="fr ac">
                        <div v-show="latitude && longitude" class="distance fr ac">
                            <div class="icoBox center">
                                <img src="../../../static/imgs/movie/location.png" alt="">
                            </div>
                            <span>{{item.distance | formatDistance}}KM</span>
                        </div>
                        <!-- <div class="rating fr ac">
                            <div class="icoBox center">
                                <img src="../../../static/imgs/movie/star.png" alt="">
                            </div>
                            <span>9.9分</span>
                        </div> -->
                    </div>
                </div>
                <button>选座</button>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
import { Indicator, MessageBox, Toast } from "mint-ui";
export default {
    data() {
        return {
            cinemaList: [],
            movieid: this.$route.query.movieid,
            citycode: this.getLocal("selectedCityCode") ? this.getLocal("selectedCityCode") : this.$route.query.citycode,
            page: 0,
            countycode: this.getLocal("countycode") ? this.getLocal("countycode") : "",
            selectedCity: this.getLocal('selectedCity') ? this.getLocal('selectedCity') : this.getLocal('currentCity') ? this.getLocal('currentCity') : '上海',
            selectedCounty: this.getLocal("selectedCounty") ? this.getLocal("selectedCounty") : "不限",
            latitude: this.getLocal("locationInfo") && this.getLocal("locationInfo").lat ? this.getLocal("locationInfo").lat : "",
            longitude: this.getLocal("locationInfo") && this.getLocal("locationInfo").lng ? this.getLocal("locationInfo").lng : "",
            openid: this.getLocal("openid") ? this.getLocal("openid") : "", //微信openid
            code: sessionStorage.getItem("code")
                ? sessionStorage.getItem("code")
                : "" //获取微信openid需要的code
        };
    },
    components: {
        navBar
    },
    created() {
        let auth_code = decodeURIComponent((new RegExp('[?|&]' + 'auth_code' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
        let appkey = decodeURIComponent((new RegExp('[?|&]' + 'appkey' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
        console.log('selectedCity', this.getLocal('selectedCity'))
        console.log("query", this.$route.query)
        if(!this.$route.query.citycode && !this.getLocal('selectedCity')){
            this.getCityList()
        }
        if(auth_code){
            this.setLocal("hasLogged", true);
            this.setLocal("auth_code", auth_code);
        }
        if (this.code && !this.openid) {
            this.getOpenId();
        }
        if(appkey){
            this.setLocal("appkey", appkey);
            this.$global.appkey = appkey;
        }
    },
    // destroyed(){
    //     this.removeLocal("countycode");
    //     this.removeLocal("selectedCounty");
    // },
    activated(){
        this.page = 0;
    },
    methods: {
        // 获取微信openid
        getOpenId() {
            this.$post({
                method: "weixin.get.openid",
                code: this.code
            }).then(res => {
                if (res.success) {
                    this.openid = res.data;
                    this.setLocal("openid", res.data);
                }
            });
        },
        //获取城市列表
        getCityList() {
            this.removeLocal("selectedCity");
            this.removeLocal("selectedCityCode");
            this.removeLocal("currentCity");
            this.removeLocal("currentCityCode");
            this.removeLocal("countycode");
            this.removeLocal("selectedCounty");
            this.removeLocal("locationInfo");
            this.$post({
                method: "movie.city.list"
            }).then(res => {
                if (res.success) {
                    this.citylist = res.data.citylist;
                    if (!this.getLocal("currentCity")) {
                        console.log(this.getLocal("currentCity"));
                        try {
                            this.getLocation();
                        } catch (error) {
                            Indicator.close();
                            Toast({
                                message: error,
                                position: "middle",
                                duration: 2000,
                                className: "toastBox"
                            });
                        }
                    }
                }
            });
        },
        // 定位
        getLocation() {
            Indicator.open("定位中...");
            let _this = this;
            AMap.plugin("AMap.Geolocation", function() {
                var geolocation = new AMap.Geolocation({
                    // 是否使用高精度定位，默认：true
                    enableHighAccuracy: true,
                    // 设置定位超时时间，默认：无穷大
                    timeout: 5000
                });
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, "complete", onComplete);
                AMap.event.addListener(geolocation, "error", onError);
                // data是具体的定位信息
                function onComplete(data) {
                    Indicator.close();
                    console.log("具体的定位信息", data);
                    _this.setLocal("locationInfo", data.position);
                    _this.matchCityCode(data.formattedAddress);
                }
                function onError(data) {
                    // 失败 启用 ip定位
                    Indicator.close();
                    AMap.plugin("AMap.CitySearch", function() {
                        var citySearch = new AMap.CitySearch();
                        citySearch.getLocalCity(function(status, result) {
                            if (status === "complete" && result.info === "OK") {
                                // 查询成功，result即为当前所在城市信息
                                console.log("通过ip获取当前城市：", result);
                                _this.matchCityCode(result.city);
                            }
                        });
                    });
                }
            });
        },
        matchCityCode(txt) {
            for (let i of this.citylist) {
                if (txt.indexOf(i.name) >= 0) {
                    console.log(i.citycode);
                    this.selectedCity = i.name;
                    this.citycode = i.citycode;
                    this.setLocal("currentCity", i.name);
                    this.setLocal("currentCityCode", i.citycode);
                    break;
                }
            }
            if (!this.getLocal("currentCity")) {
                MessageBox.confirm("定位失败，是否手动选择城市?")
                    .then(action => {
                        if (action == "confirm") {
                            this.$router.push("/cityList");
                        }
                    })
                    .catch(err => {});
            } else {
                // this.getCinemaList();
                this.loadMore();
            }
        },
        // 获取电影院列表
        getCinemaList() {
            this.$post({
                // method: "movie.cinema.list",
                method: "movie.new.cinema.list",
                movieid: this.movieid,
                citycode: this.citycode,
                countycode: this.countycode,
                latitude: this.getLocal("locationInfo") && this.getLocal("locationInfo").lat ? this.getLocal("locationInfo").lat : "",
                longitude: this.getLocal("locationInfo") && this.getLocal("locationInfo").lng ? this.getLocal("locationInfo").lng : "",
                page_no: this.page
            }).then(res => {
                if (res.success) {
                    this.cinemaList = this.cinemaList.concat(
                        res.data.cinemalist
                    );
                }
            });
        },
        goCinemaMovie(cinemaid) {
            // 微信环境需要openid
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf("micromessenger") != -1 ? true : false;
            if (isWeixin && !this.openid) {
                let domain = window.location.protocol+"//"+window.location.host;  // 域名
                let auth_code = this.$route.query.auth_code ? this.$route.query.auth_code : ""
                const url = encodeURI(
                    domain +  "/duwap/static/getCode/getCode.html?usertype=guangming&auth_code=" + auth_code
                );
                window.location.href = url;
                return;
            }
            this.$router.push({
                path: "/cinemaMovieList",
                query: {
                    movieid: this.movieid,
                    citycode: this.citycode,
                    cinemaid: cinemaid
                }
            });
        },
        // 加载更多
        loadMore() {
            this.getCinemaList();
            this.page++;
        },
        switchCity(){
            this.$router.push({path: "/cityList"})
        },
        districtFilter(){
            this.$router.push({path: "/districtFilter", query: {citycode: this.citycode}})
        },
        searchCinema(){
            this.$router.push({path: "/searchCinema", query: {movieid: this.movieid, citycode: this.citycode}})
        }
    }
};
</script>
<style lang="scss">
@import "../../../static/css/base";
.cinemaListWrap {
    .filterBar {
        height: 98px;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        font-size: 24px;
        position: fixed;
        top: 0;
        .addressFilter {
            div {
                margin-right: 20px;
                .downIco {
                    width: 24px;
                    height: 20px;
                    margin-right: 10px;
                }
                span {
                    font-size: 32px;
                    color: $themeColor;
                }
            }
        }
        .searchIco {
            width: 32px;
            height: 32px;
            margin-right: 10px;
        }
    }
    .listWrap{
        padding-top: 98px;
        .listItem {
            width: 100%;
            height: 220px;
            padding: 42px 30px;
            box-sizing: border-box;
            background-color: #fff;
            border-bottom: 1px solid #ddd;
            .infoBox {
                width: calc(100% - 166px);
                height: 136px;
                h3 {
                    font-size: 32px;
                }
                .addr {
                    color: #999;
                    font-size: 24px;
                }
                .distance {
                    height: 40px;
                    border: 1px solid #3699FF;
                    border-radius: 6px;
                    margin-right: 20px;
                    color: #3699FF;
                    .icoBox {
                        width: 40px;
                        height: 40px;
                        background: #3699FF;
                        border-radius: 6px 0 0 6px;
                        img {
                            width: 26px;
                            height: 26px;
                        }
                    }
                    span {
                        font-size: 22px;
                        padding: 0 10px;
                    }
                }
                .rating {
                    height: 40px;
                    border: 1px solid #F19927;
                    border-radius: 6px;
                    color: #F19927;
                    .icoBox {
                        width: 40px;
                        height: 40px;
                        background: #F19927;
                        border-radius: 6px 0 0 6px;
                        img {
                            width: 30px;
                            height: 30px;
                        }
                    }
                    span {
                        padding: 0 10px;
                    }
                }
            }
            button {
                width: 146px;
                height: 60px;
                line-height: 60px;
                background:#E42F46;
                border-radius:6px;
                font-size: 32px;
                color: #fff;
            }
            // h3 {
            //     font-size: 30px;
            // }
            // span {
            //     font-size: 24px;
            //     line-height: 34px;
            // }
            // .addr {
            //     padding-right: 20px;
            // }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/cinemaList.vue